// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import TabsController from "./tabs_controller"
application.register("tabs", TabsController)

import TradingviewWidgetController from "./tradingview_widget_controller"
application.register("tradingview-widget", TradingviewWidgetController)

import CandleTableController from "./candle_table_controller"
application.register("candle-table", CandleTableController)

import PriceChartController from "./price_chart_controller"
application.register("price-chart", PriceChartController)

import BotChartController from "./bot_chart_controller"
application.register("bot-chart", BotChartController)

import PositionsTableController from "./positions_table_controller"
application.register("positions-table", PositionsTableController)
